import React, { Fragment } from "react";
import { inject, observer } from "mobx-react";
import { styled } from "../../../stitches.config";

import PhotoOnLeft from "../../common/PhotoOnLeft";
import PhotoOnTop from "../../common/PhotoOnTop";
import { withlazyload } from '../../HOCs/WithLazyLoad';
import { pushDataLayer } from "../../../helpers/pushDataLayer";

@withlazyload({
  height: 800,
  once: true,
  offset: 600
})
@inject("ArticleStore", "CategoryStore", "UIStore")
@observer
export default class SeeAlsoArticles extends React.Component {
  render() {
    const { ArticleStore, similarArticles } = this.props;
    const isMobile = (window.innerWidth < 992);
    const dataLayerObject = {
      'event': 'contentRecommendationSystem',
      'systemType': 'Zobacz także',
      'articleUrl': `/${ArticleStore.currentSlug}`,
      'articleTitle': ArticleStore.article.seo_title,
      'articleSection': ArticleStore.article.category.name,
      'articleTag': ArticleStore.fetchedArticle.topics.length > 0 ? ArticleStore.fetchedArticle.topics[0].name : '',
      'articleAuthor': ArticleStore.fetchedArticle.DATA_LAYER.articleAuthor,
      'articleCharacterRange': ArticleStore.fetchedArticle.DATA_LAYER.articleCharacterRange
    }
    return (
      <Wrapper>
        {similarArticles &&
          similarArticles.length > 0 && (
            <Fragment>
              <Header> Zobacz także<span>:</span> </Header>
              {similarArticles.map((article, i) => {
                return (<Article key={"similar_articles__" + i}>
                  {i < 4 && isMobile
                    ? <PhotoOnTop article={article} handleClick={() => pushDataLayer(dataLayerObject)} />
                    : <PhotoOnLeft article={article} handleClick={() => pushDataLayer(dataLayerObject)} />
                  }
                </Article>);
              })}
            </Fragment>
          )}
      </Wrapper>
    );
  }
}

const Wrapper = styled("div", {
  margin: "14px 0",
  "@media (min-width: 992px)": {
    margin: "14px auto"
  }
});

const Header = styled("div", {
  fontSize: "15px",
  fontWeight: 500,
  letterSpacing: "-0.3px",
  color: "#222",
  span: {
    color: "$primary",
    fontWeight: 500
  }
});

const Article = styled("div", {
  margin: 0
});